export enum QueryKey {
  CUSTOMER = 'customer',
  CUSTOMERS = 'customers',
  LOYVERSE_ITEMS = 'loyverse-items',
  LOYVERSE_CUSTOMERS = 'loyverse-customers',
  GOOGLE_CONTACTS = 'google-contacts',
  COUNTRIES = 'countries',
  ORDERS = 'orders',
  DELIVERY_GROUPS = 'delivery-groups',
  TRUCKS = 'trucks',
  UNASSIGNED_DELIVERY_ADDRESSES = 'unassigned-delivery-addresses',
  DELIVERY_GROUP_ADDRESSES = 'delivery-group-addresses',
  NEXT_DELIVERY_DATE = 'next-delivery-date',
  GROUP_NEXT_DELIVERY_DATE = 'group-next-delivery-date',
  PLANNING_SETTINGS = 'planning-settings',
  DRIVERS = 'drivers',
  ITEM_BOTTLE_VALUES = 'item-bottle-values',
  MISSED_ORDERS = 'missed-orders',
  ROUTE = 'route',
  RECEIPT_INBOX = 'receipt-inbox',
  SUBSCRIPTIONS = 'subscriptions',
  UPCOMING_ACTIONS = 'upcoming-actions',
  MAP_PINS = 'map-pins',
  DASHBOARD_TOTALS = 'dashboard-totals',
  AGENT_ORDERABLE_ITEMS = 'agent-orderable-items',
  AGENT_TURNS = 'agent-turns',
  AGENT_SETTINGS = 'agent-settings',
  KNOWLEDGE_BASE = 'knowledge-base',
  AGENT_ORDERS_AWAITING_REVIEW = 'agent-orders-awaiting-review',
  DATA_CLEANSING = 'data-cleansing',
  WEEKLY_MESSAGE_SENDS = 'weekly-message-sends',
  PAYMENT_METHODS = 'payment-methods',
  PAYMENTS = 'payments'
}
